// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-cards-container {
  position: relative;
}
.summary-cards-container .summary-delete-btn {
  position: absolute;
  top: -5px;
  right: -5px;
  z-index: 20;
  color: #666;
}
.summary-cards-container .summary-delete-btn:hover {
  color: #dc3545;
}
.summary-cards-container .summary-delete-btn .p-button-text {
  padding: 0.5rem;
}
.summary-cards-container .summary-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}
.summary-cards-container .summary-cards .summary-card {
  padding: 12px 15px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.2s;
  position: relative;
}
.summary-cards-container .summary-cards .summary-card:not(:last-child)::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 80%;
  width: 1px;
  background: linear-gradient(180deg, transparent 0%, #d0d0d0 20%, #d0d0d0 80%, transparent 100%);
}
.summary-cards-container .summary-cards .summary-card:hover {
  background-color: #f8f9fa;
}
.summary-cards-container .summary-cards .summary-card .summary-count {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 6px 0;
}
.summary-cards-container .summary-cards .summary-card .summary-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0 0 4px 0;
}
.summary-cards-container .summary-cards .summary-card .summary-description {
  font-size: 10px;
  color: #666;
  margin: 0;
  line-height: 1.3;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Tabs/SummaryView/SummaryView.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;AACR;AACQ;EACI,cAAA;AACZ;AAEQ;EACI,eAAA;AAAZ;AAII;EACI,aAAA;EACA,qCAAA;EACA,MAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAFR;AAIQ;EACI,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;AAFZ;AAIY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,UAAA;EACA,+FAAA;AAFhB;AAKY;EACI,yBAAA;AAHhB;AAMY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAJhB;AAOY;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AALhB;AAQY;EACI,eAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;AANhB","sourcesContent":[".summary-cards-container {\n    position: relative;\n\n    .summary-delete-btn {\n        position: absolute;\n        top: -5px;\n        right: -5px;\n        z-index: 20;\n        color: #666;\n\n        &:hover {\n            color: #dc3545;\n        }\n\n        .p-button-text {\n            padding: 0.5rem;\n        }\n    }\n\n    .summary-cards {\n        display: grid;\n        grid-template-columns: repeat(4, 1fr);\n        gap: 0;\n        border: 1px solid #e0e0e0;\n        border-radius: 8px;\n        background: #fff;\n        overflow: hidden;\n\n        .summary-card {\n            padding: 12px 15px;\n            text-align: center;\n            cursor: pointer;\n            transition: background-color 0.2s;\n            position: relative;\n\n            &:not(:last-child)::after {\n                content: '';\n                position: absolute;\n                right: 0;\n                top: 50%;\n                transform: translateY(-50%);\n                height: 80%;\n                width: 1px;\n                background: linear-gradient(180deg, transparent 0%, #d0d0d0 20%, #d0d0d0 80%, transparent 100%);\n            }\n\n            &:hover {\n                background-color: #f8f9fa;\n            }\n\n            .summary-count {\n                font-size: 24px;\n                font-weight: 700;\n                margin: 0 0 6px 0;\n            }\n\n            .summary-title {\n                font-size: 14px;\n                font-weight: 600;\n                color: #333;\n                margin: 0 0 4px 0;\n            }\n\n            .summary-description {\n                font-size: 10px;\n                color: #666;\n                margin: 0;\n                line-height: 1.3;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
